import { createSlice } from '@reduxjs/toolkit'
import { RootState } from '../store/store';

interface PadvishRequestSliceState {
    list: any,
  }
  
const initialState:PadvishRequestSliceState = {
    list:undefined,
}

export const PadvishRequestSlice = createSlice({
    name:"padvishRequestList",
    initialState,
    reducers:{
        UpdatePadvishRequestList: (state,action) => {
            state.list = action.payload.padvishRequestList;
        },
        AddPadvishRequest: (state,action) => {
            state.list = undefined;
        },
        EditPadvishRequest: (state,action) => {
            state.list = undefined;
        },
        RemovePadvishRequest: (state,action) => {
            state.list = undefined;
        }
    }
})

export const {UpdatePadvishRequestList,AddPadvishRequest,EditPadvishRequest,RemovePadvishRequest} = PadvishRequestSlice.actions

export const selectPadvishRequestList = (state: RootState) => state.padvishRequestList

export default PadvishRequestSlice.reducer;